'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./login/login'));
    processInclude(require('./loyalty/loyaltyDrawer'));
    processInclude(require('./togglePassword'));
});
